// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3stGw","submit":"style_submit__3Sfo1","verifyBut":"style_verifyBut__3cs5U"};